import { Animation } from '../../../Animation/src/modules/api.js';
import { activateItems, startAutoLoop } from './activate';
import * as Container from './container';
import { addClickEventListeners, addMouseEventListeners } from './events';
import { classNames, selectors } from './lib';
import * as Utils from './utils';

export const content = {};
window.theater = content;

// Set the height of the container to the height of the highest element.
const setCtrHeight = (ctr, ctrId) => {
	const largest = content[ctrId].objs.reduce((prev, current) => {
		return prev.height < current.height ? prev : current;
	});

	ctr.querySelector(selectors.stage).setAttribute('style', `--height: ${largest.height}px`);
};

// Checks if all elements have been loaded by checking an array of objects for the loaded flag.
// ! Currently not in use because of a too long init delay
// TODO: Remove if not needed anymore
// const onStageContentLoaded = (ctrId) => {
// 	// Show content as soon as every stage content has loaded.
// 	if (!content[ctrId].objs.find((el) => el.loaded === false)) {
// 		showContent(ctrId);
// 	}
// };

// Sets the loaded attribute to the primary container, which displays the entire component.
const showContent = (ctrId) => {
	const ctr = document.getElementById(ctrId);

	if (!Container.hasLoaded(ctr)) activateItems(ctrId);

	if (ctr.classList.contains(classNames.desktop)) {
		if (Container.isPaused(ctr)) startAutoLoop(ctrId);
		setCtrHeight(ctr, ctrId);
	}

	document.getElementById(ctrId).setAttribute('data-loaded', '1');
};

// Sets up an array of the primary elements for each component instance for easy reference at any time.
const setInstanceIndex = (ctrId, index, el, nav) => {
	content[ctrId].objs[index] = {
		ctr: el,
		nav,
		el: {},
		loaded: false,
		active: false,
	};
};

// Object entries that all content entries have in common.
const fillContentObjectWithValues = (contentObj, type, node, height = 0) => {
	contentObj.type = type;
	contentObj.el = node;
	contentObj.loaded = true;
	contentObj.height = height;
};

// Runs once over all content elements and collects/processes all different content types.
export const theaterInit = (ctr) => {
	ctr.addEventListener('theaterFirstItemLoaded', () => {
		showContent(ctr.id);
	});

	// Add container data to global content
	content[ctr.id] = {
		session: {
			index: 0,
			duration: 0,
			timeLeft: 0,
		},
	};

	// Initialize empty array
	content[ctr.id].objs = [];

	const theaterContentSlides = ctr.querySelectorAll(selectors.content);
	const theaterNavEntries = ctr.querySelectorAll(selectors.nav);

	// Event Listeners
	if (Container.hasAutoplay(ctr)) {
		theaterContentSlides.forEach(addMouseEventListeners);
		theaterNavEntries.forEach(addMouseEventListeners);
	}
	theaterNavEntries.forEach(addClickEventListeners);

	// Prefill an array of content objects to let the instance know what to load.
	theaterContentSlides.forEach((contentSlide, index) => {
		setInstanceIndex(ctr.id, index, contentSlide, theaterNavEntries[index]);
	});

	theaterContentSlides.forEach((el) => {
		const type = el.getAttribute('data-type');
		const index = Utils.getIndex(el);
		const loop = el.getAttribute('data-loop');
		const contentObj = content[ctr.id].objs[index];
		const isFirstSlide = index === 0;

		switch (type) {
			case 'video': {
				/**
				 * Video
				 */
				const video = el.querySelector(selectors.video);

				video.load();
				video.addEventListener('loadeddata', (event) => {
					fillContentObjectWithValues(contentObj, type, video, el.offsetHeight);

					// Remove the thousand indicator from the number and get back a integer.
					const milliseconds = parseInt(event.target.duration.toString().replace('.', ''));

					Utils.calculatePlayTime(contentObj, milliseconds, loop);

					isFirstSlide && ctr.dispatchEvent(new Event('theaterFirstItemLoaded'));
				});
				break;
			}
			case 'animation': {
				/**
				 * Animation
				 */
				const canvas = el.querySelector('canvas');
				new Animation(canvas, canvas.getAttribute('data-src'), {
					autoplay: true,
					loop: true,
					workerId: 'theater',
					onLoad: (animation) => {
						fillContentObjectWithValues(contentObj, type, animation, el.offsetHeight);

						contentObj.totalFrames = animation.totalFrames;
						contentObj.frameRate = animation.frameRate;

						Utils.calculatePlayTime(contentObj, Utils.getAnimationDurationInMilliseconds(contentObj.totalFrames, contentObj.frameRate), loop);
						isFirstSlide && ctr.dispatchEvent(new Event('theaterFirstItemLoaded'));
					},
				});
				break;
			}
			case 'image': {
				/**
				 * Image
				 */
				const image = el.querySelector(selectors.image);

				fillContentObjectWithValues(contentObj, type, image, el.offsetHeight);
				isFirstSlide && ctr.dispatchEvent(new Event('theaterFirstItemLoaded'));

				break;
			}
		}

		content[ctr.id].objs[index] = contentObj;
	});
};
